module.exports = __webpack_public_path__ + "media/cases-brand-illumcare-lazyload-11.739e065f.mp4";